/** Parse Postgres money type strings like "$500.00" into numbers */
export const parseMoney = (value: unknown): number => {
  if (typeof value === "number") return value;
  const n = parseFloat(String(value ?? "0").replace(/[^0-9.-]/g, ""));
  return isNaN(n) ? 0 : n;
};
